import { render, staticRenderFns } from "./GiveawayEmbed.vue?vue&type=template&id=3b3f4fde&scoped=true&lang=pug&"
import script from "./GiveawayEmbed.vue?vue&type=script&lang=js&"
export * from "./GiveawayEmbed.vue?vue&type=script&lang=js&"
import style0 from "./GiveawayEmbed.vue?vue&type=style&index=0&id=3b3f4fde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3f4fde",
  null
  
)

export default component.exports